/*
 * @Description:
 * @Date: 2021-10-08 14:13:15
 */
if ((window as any).__POWERED_BY_QIANKUN__) {
  // eslint-disable-next-line no-undef
  Reflect.set(
    window,
    '__webpack_public_path__',
    (window as any).__INJECTED_PUBLIC_PATH_BY_QIANKUN__
  );
}
